export interface IUserPreferenceGeneralListItem {
  type: string
  value: string
}

export type MapViewBaseLayer = 'vector' | 'satellite' | 'terrain'

export enum IUserPreferenceGeneralListItemType {
  ListMode = 'listMode',
  ExpressView = 'expressView',
  LeadDensityMode = 'leadDensityMode',
  UsersDensityMode = 'usersDensityMode',
  UsersPageSize = 'usersPageSize',
  SCWebHooksDensityMode = 'scWebHooksDensityMode',
  RolesDensityMode = 'rolesDensityMode',
  RolesPageSize = 'rolesPageSize',
  WorkWaveDensityMode = 'workWaveContactDuplicatesDensityMode',
  WorkWavePageSize = 'workWaveContactDuplicatesPageSize',
  PestPacLocationDensityMode = 'pestPacLocationDuplicatesDensityMode',
  PestPacLocationPageSize = 'pestPacLocationDuplicatesPageSize',
  DraftLeadDensityMode = 'draftLeadDensityMode',
  OpportunityDensityMode = 'opportunityDensityMode',
  GuestUserDashboardLeadsDensityMode = 'guestUserDashboardLeadsDensityMode',
  GuestUserDashboardLeadsPageSize = 'guestUserDashboardLeadsPageSize',
  GuestUserDashboardOpportunitiesDensityMode = 'guestUserDashboardOpportunitiesDensityMode',
  GuestUserDashboardOpportunitiesPageSize = 'guestUserDashboardOpportunitiesPageSize',
  NoteViewSortOrder = 'NoteViewSortOrder',
  NoteViewPestPacOn = 'NoteViewPestPacOn',
  LeadFilterShow = 'LeadFilterShow',
  OpportunityFilterShow = 'OpportunityFilterShow',
  ManageAgreementWidgetFilter = 'ManageAgreementWidgetFilter',
  CloseWonQueueSubmissionsWidgetFilter = 'CloseWonQueueSubmissionsWidgetFilter',
  ImportDensityMode = 'ImportDensityMode',
  ImportColumnsSettings = 'ImportColumnsSettings',
  EntityAnnualServiceOccurrencesSubtractOne = 'EntityAnnualServiceOccurrencesSubtractOne',
  MapViewFilteredEntityTypes = 'MapViewFilteredEntityTypes',
  MapViewFilteredMyRecords = 'MapViewFilteredMyRecords',
  MapViewFilteredSalespersonIds = 'MapViewFilteredSalespersonIds',
  ShowMapViewFilterChips = 'ShowMapViewFilterChips',
  MapViewFilteredKnockStatuses = 'MapViewFilteredKnockStatuses',
  MapViewKnownKnockStatusIds = 'MapViewKnownKnockStatusIds',
  MapViewBaseLayer = 'MapViewBaseLayer',
  CollisionDetectionEnabled = 'CollisionDetectionEnabled',
  UnifiedCalendarView = 'UnifiedCalendarView',
  NoteViewKnockStatusOn = 'NoteViewKnockStatusOn',
  LeadPageSize = 'leadPageSize',
  OpportunityPageSize = 'opportunityPageSize',
  PendingLeadPageSize = 'pendingLeadPageSize',
  UnifiedCalendarFilteredSources = 'unifiedCalendarFilteredSources',
  UnifiedCalendarFilteredSCEventTypes = 'unifiedCalendarFilteredSCEventTypes',
  UnifiedCalendarFilteredActivityTypes = 'unifiedCalendarFilteredActivityTypes',
  UnifiedCalendarKnownActivityTypeIds = 'unifiedCalendarKnownActivityTypeIds',
}
